
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import ProductTable from '../../components/docs/ProductTable';
export const metadata = {
  toc: true,
  maxTocLevel: 5,
  layout: 'guide',
  description: 'Overview and comparison of Plaid KYC, AML, and anti-fraud solutions'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='KYC, AML, and anti-fraud products' subtitle='Review and compare solutions' subsubtitle="Overview and comparison of KYC, AML, and anti-fraud solutions" bottomBorder={true} mdxType="Header" />
    <p>{`Plaid offers Identity Verification for KYC (Know Your Customer) compliance, Monitor for AML (Anti-Money Laundering) compliance, and Protect for anti-fraud. The three products are tightly integrated and managed through a single dashboard but can also be used separately. `}</p>
    <Callout mdxType="Callout">
      <p>{`Plaid Identity (along with Identity Match) can also be used as an account-takeover-fraud signal for payments use cases. You can learn more about it on the `}<a parentName="p" {...{
          "href": "/docs/payments"
        }}>{`Payments products`}</a>{` page.`}</p>
    </Callout>
    <h4 {...{
      "id": "identity-verification"
    }}>{`Identity Verification`}</h4>
    <p><a parentName="p" {...{
        "href": "/docs/identity-verification"
      }}>{`Identity Verification`}</a>{` is Plaid's KYC solution. Via an interactive session with the user, Identity Verification allows you to check user-provided identity information such as name, ID number, phone number, and address against high-trust identity databases; check identity documents for expiration, signs of fraud, or mismatch with other user-provided data; run selfie verification to confirm liveness and photo ID matching; verify a user's phone number via SMS; and analyze a user's session, behavior, and identity details for signs of fraud. Identity Verification can also be run as a fully background session without interactivity (for checking pre-collected user data against databases only). Identity Verification can plug directly into Monitor for automatic AML watchlist scanning. `}</p>
    <p>{`Identity Verification is a separate product from Identity / Identity Match, but can integrate directly with `}<a parentName="p" {...{
        "href": "/docs/identity/#identity-match"
      }}>{`Identity Match`}</a>{` to reduce account takeover fraud risk when a user has linked a financial account to your application. Identity Match will verify that the ownership details (such as name, address, and phone number) on the linked account match the data verified via Identity Verification.`}</p>
    <h4 {...{
      "id": "monitor"
    }}>{`Monitor`}</h4>
    <p><a parentName="p" {...{
        "href": "/docs/monitor"
      }}>{`Monitor`}</a>{` provides AML capabilities, screening users against PEP (Politically Exposed Person) and sanction lists. Monitor is frequently used with Identity Verification -- integrating Monitor into an existing Identity Verification deployment can be as simple as checking a box on your Identity Verification template -- but can also be deployed separately. Any watchlist hits will be exposed via both a user-friendly dashboard UI and via API, for use with either manual or automated review workflows.`}</p>
    <h4 {...{
      "id": "monitor-and-identity-verification-comparison"
    }}>{`Monitor and Identity Verification comparison`}</h4>
    <ProductTable mdxType="ProductTable">
      {`
|                         | Identity Verification                                                        | Monitor                                          |
|-------------------------|------------------------------------------------------------------------------|--------------------------------------------------|
| Summary                 | Flexible and configurable KYC compliance to verify identity and detect fraud | Scan users against watchlists for AML compliance |
| Supported countries     | nearly 190 countries                                                               | 190+ countries                                   |
| UI languages            | English, French, Spanish, Japanese, Portuguese                               | N/A                                              |
| Billing plans available | Pay-as-you-go or 12-month contract                                           | Pay-as-you-go or 12-month contract               |
`}
    </ProductTable>
    <h4 {...{
      "id": "protect"
    }}>{`Protect`}</h4>
    <p>{`Protect (US only) is Plaid's anti-fraud solution, designed to detect fraud across the user lifecycle. Protect uses Plaid's network-wide data to generate a dynamic Trust Index score, helping you apply the right friction at the right time. It also includes an investigative toolkit for fraud teams to identify fraud rings and quickly deploy mitigating rules.`}</p>
    <p>{`Protect is currently in early availability. To request access, contact your account manager or `}<a parentName="p" {...{
        "href": "https://plaid.com/contact/"
      }}>{`sales`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "identity-verification",
        level: 4,
        title: "Identity Verification",
      },
{
        id: "monitor",
        level: 4,
        title: "Monitor",
      },
{
        id: "monitor-and-identity-verification-comparison",
        level: 4,
        title: "Monitor and Identity Verification comparison",
      },
{
        id: "protect",
        level: 4,
        title: "Protect",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
